import React from 'react';
import DesktopAdhesionFs from './freestar/Adhesion';
const DesktopAdhesion = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopAdhesionFs, {
        safety: safety
    });
};
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
